'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _integrations = require('./integrations');

var _integrations2 = _interopRequireDefault(_integrations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Integrations = function (_React$Component) {
    _inherits(Integrations, _React$Component);

    function Integrations() {
        _classCallCheck(this, Integrations);

        return _possibleConstructorReturn(this, (Integrations.__proto__ || Object.getPrototypeOf(Integrations)).apply(this, arguments));
    }

    _createClass(Integrations, [{
        key: '_onLoad',
        value: function _onLoad(e) {
            var el = e.target;
            if (el.width > el.height * 2) {
                el.className = 'landscape';
            }
        }
    }, {
        key: 'renderIntegration',
        value: function renderIntegration(props) {
            return _react2['default'].createElement(
                'a',
                { className: 'm-integrations__item', key: props.name, href: props.href, target: '_blank', rel: 'noopener noreferrer' },
                _react2['default'].createElement(
                    'div',
                    { className: 'content' },
                    _react2['default'].createElement('img', { src: require('./assets/' + props.src + '.svg'),
                        onLoad: this._onLoad,
                        'aria-hidden': true }),
                    _react2['default'].createElement(
                        'div',
                        { className: 'text' },
                        _react2['default'].createElement(
                            'span',
                            null,
                            props.name
                        ),
                        _react2['default'].createElement(
                            'span',
                            null,
                            props.desc
                        )
                    )
                )
            );
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {

            var script = document.createElement('script');

            script.src = 'https://zapier.com/zapbook/embed/widget.js?services=hellosign&container=true&limit=5&html_id=zapiermount';
            script.async = true;
            $(script).appendTo('#zapiermount');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2['default'].createElement(
                'div',
                { className: 'm-integrations' },
                _react2['default'].createElement(
                    'header',
                    { className: 'text-center l-margin-t-120' },
                    _react2['default'].createElement('img', { src: require('./assets/integrations_icon.svg'), className: 'l-margin-b-15' }),
                    _react2['default'].createElement(
                        'h1',
                        { className: 'l-margin-b-10' },
                        'HELLOSIGN INTEGRATIONS'
                    ),
                    _react2['default'].createElement(
                        'span',
                        null,
                        'Extend eSignatures'
                    ),
                    _react2['default'].createElement(
                        'h2',
                        { className: 'l-margin-t-20' },
                        'HelloSign connects with the services you already use to power your business.'
                    )
                ),
                _react2['default'].createElement('a', { name: 'google-integrations' }),
                _react2['default'].createElement(
                    'section',
                    { className: 'google-integrations row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'header' },
                        _react2['default'].createElement(
                            'h3',
                            null,
                            'GOOGLE INTEGRATIONS'
                        )
                    ),
                    _integrations2['default'].googleIntegrations.map(function (int) {
                        return _this2.renderIntegration(int);
                    })
                ),
                _react2['default'].createElement('a', { name: 'business-applications' }),
                _react2['default'].createElement(
                    'section',
                    { className: 'business-applications row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'header' },
                        _react2['default'].createElement(
                            'h3',
                            null,
                            'BUSINESS APPLICATIONS'
                        )
                    ),
                    _integrations2['default'].businessApplications.map(function (int) {
                        return _this2.renderIntegration(int);
                    })
                ),
                _react2['default'].createElement('a', { name: 'event-waivers' }),
                _react2['default'].createElement(
                    'section',
                    { className: 'event-waivers row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'section-title' },
                        _react2['default'].createElement(
                            'h3',
                            null,
                            'EVENT WAIVERS AND FORMS'
                        )
                    ),
                    _integrations2['default'].eventWaivers.map(function (int) {
                        return _this2.renderIntegration(int);
                    })
                ),
                _react2['default'].createElement('a', { name: 'insurance-tools' }),
                _react2['default'].createElement(
                    'section',
                    { className: 'insurance-tools row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'section-title' },
                        _react2['default'].createElement(
                            'h3',
                            null,
                            'INSURANCE TOOLS'
                        )
                    ),
                    _integrations2['default'].insuranceTools.map(function (int) {
                        return _this2.renderIntegration(int);
                    })
                ),
                _react2['default'].createElement('a', { name: 'zapier' }),
                _react2['default'].createElement(
                    'section',
                    { className: '3rd-party-integrations row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'section-title' },
                        _react2['default'].createElement(
                            'h3',
                            null,
                            'THIRD PARTY INTEGRATIONS!'
                        )
                    ),
                    _integrations2['default'].thirdParty.map(function (int) {
                        return _this2.renderIntegration(int);
                    }),
                    _react2['default'].createElement('br', null),
                    _react2['default'].createElement('div', { id: 'zapiermount' })
                ),
                _react2['default'].createElement(
                    'section',
                    { className: 'footer' },
                    _react2['default'].createElement(
                        'span',
                        null,
                        'Looking to partner to extend HelloSign\'s eSignature tools to your users?'
                    ),
                    _react2['default'].createElement(
                        'a',
                        { href: 'mailto:bizdev@hellosign.com?subject=HelloSign Partnership' },
                        _react2['default'].createElement(
                            'span',
                            null,
                            'Reach out to our Business Development team.'
                        )
                    )
                )
            );
        }
    }]);

    return Integrations;
}(_react2['default'].Component);

module.exports = Integrations;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/integrations/index.jsx
 ** module id = 1594
 ** module chunks = 0
 **/